module.exports = __webpack_public_path__ + "images/category_lp/art_work/new/assessment_achievements/3@2x_c57b21e36137b74c28f0f77c8932731a.png";